import { Sale } from ".";

export class DeletedPurchase {
	ID:number = 0;
	PurchaseID:number = 0;
	ContactID:number = 0;
	DeletedDate:Date = new Date();
	ComputedFriendlyID:string = "";
	JsonData:Sale = new Sale();
	Trace:string = "";
	RawJson:string = "";
	DeletedByUserID:number = 0;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.PurchaseID = data.PurchaseID;
		this.ContactID = data.ContactID;
		this.DeletedDate = new Date(data.DeletedDate);
		this.ComputedFriendlyID = data.ComputedFriendlyID;
		this.RawJson = data.JsonData;
		this.JsonData = new Sale(JSON.parse(data.JsonData));
		this.Trace = data.Trace;
		this.DeletedByUserID = data.DeletedByUserID;
	}
}